import { useUser } from "contexts/userContext/userContext.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";

const useUserStorage = () => {
  const { getUserData } = useUser();
  const sizeMax = bytesToDisplayHelper(getUserData().UserMaxStorage, true);
  const sizeInUse = bytesToDisplayHelper(getUserData().UserUsedStorage);

  const percantegeOfSpace = (
    (getUserData().UserUsedStorage / getUserData().UserMaxStorage) *
    100
  ).toFixed(2);

  return {
    sizeMax,
    sizeInUse,
    percantegeOfSpace,
  };
};

export default useUserStorage;
